import { createContext, useContext, ReactNode } from 'react';
import { useCurrentHub, CurrentHubResponse, Hub } from '@/lib/hooks/use-current-hub';

interface HubContextValue {
  currentHubData: CurrentHubResponse | null;
  hubId: string | undefined;
  managedHubs: Hub[];
  loading: boolean;
  error: Error | null;
  switchHub: (hubId: string) => Promise<void>;
  reload: () => Promise<void>;
}

const HubContext = createContext<HubContextValue | null>(null);

interface HubProviderProps {
  children: ReactNode;
}

export function HubProvider({ children }: HubProviderProps) {
  const hubData = useCurrentHub();
  
  return (
    <HubContext.Provider value={hubData}>
      {children}
    </HubContext.Provider>
  );
}

export function useHub() {
  const context = useContext(HubContext);
  if (!context) {
    throw new Error('useHub must be used within HubProvider');
  }
  return context;
}
